import ICategory from '../model/ICategory';

export const sectionHasVisibleFeatures = (categories: ICategory[], isInSalesEnablement: boolean) => {
  return isInSalesEnablement
    ? categories.filter(category => category.featuresList.features.length !== 0).length !== 0
    : categories.filter(
        category =>
          category.featuresList.features.filter(feature => !feature.attributes.salespersonViewOnly).length !== 0,
      ).length !== 0;
};
